import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, Chip } from "@mui/material";
import Swal from "sweetalert2";
import { useParent } from "../../../../../APIContext/ParentContext";
import "./index.css";
import { useNavigate } from "react-router-dom";

const Payment = () => {
  const navigate = useNavigate();
  const { fetchParentPaymentDetails, cancelSubscription } = useParent();
  const [paymentData, setPaymentData] = useState([]);
  const [refresh, setRefresh] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const result = await fetchParentPaymentDetails();
      if (result) setPaymentData(result);
      else {
        // Swal.fire({
        //   icon: "error",
        //   title: "Error",
        //   text: "Failed to fetch packages.",
        //   confirmButtonColor: "#f7931a",
        // cancelButtonColor: "#1C1C1C",
        // });

        navigate("/login");
      }
    };

    fetchData();
  }, [refresh]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    if (isNaN(date.getTime())) return "-";

    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  const handleCancel = async (sale_id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to cancel this subscription?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f7931a",
      cancelButtonColor: "#1C1C1C",
      confirmButtonText: "Yes, Cancel it!",
      cancelButtonText: "No",
    });

    if (!result.isConfirmed) return;

    const formData = new FormData();
    formData.append("sale_id", sale_id);

    const response = await cancelSubscription(formData);
    if (response?.success) setRefresh((prev) => !prev);
  };

  const columns = [
    { field: "package_name", headerName: "Package Name", flex: 1 },

    { field: "amount", headerName: "Price ($)", width: 120 },

    { field: "player", headerName: "Player", width: 120 },

    {
      field: "remaining_sessions",
      headerName: "Credits Remaining",
      width: 170,
      renderCell: (params) =>
        params.row.is_unlimited ? "Unlimited" : params.value,
    },

    {
      field: "purchase_date",
      headerName: "Purchased Date",
      width: 150,
      sortComparator: (v1, v2) => new Date(v1) - new Date(v2),
      renderCell: (params) => formatDate(params.value),
    },

    {
      field: "status",
      headerName: "Status",
      width: 130,
      renderCell: (params) => (
        <Chip
          label={params.value}
          color={params.value === "active" ? "success" : "default"}
          size="small"
        />
      ),
    },

    {
      field: "action",
      headerName: "Action",
      width: 140,
      sortable: false,
      renderCell: (params) =>
        params.row.can_cancel && params.row.status === "active" ? (
          <Button
            size="small"
            variant="contained"
            color="warning"
            onClick={() => handleCancel(params.row.sale_id)}
          >
            Cancel
          </Button>
        ) : (
          "NA"
        ),
    },
  ];

  return (
    <>
      <div
        style={{ filter: "brightness(1.28)" }}
        className="profile-content-area bg-custom"
      >
        <div className="profile-detail-container">
          <div className="player-header">
            <h2 className="text-clip">Payments Details</h2>
            {/* <button className="add-player-btn">Add New Card</button> */}
          </div>

          <div className="package-table brightness">
            <Box sx={{ height: 520, width: "99%" }}>
              <DataGrid
                rows={paymentData.map((item) => ({
                  ...item,
                  id: item.sale_id,
                }))}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: 10, page: 0 },
                  },
                }}
                pageSizeOptions={[10, 20, 50]}
                disableRowSelectionOnClick
              />
            </Box>
          </div>
        </div>
      </div>
    </>
  );
};

export default Payment;
